import React from 'react';
import PropTypes from 'prop-types';
import NumberOrTimePlusInput from './NumberOrTimePlusInput';
import {checkIfTouchedValue} from './utilities';

class Minus6Input extends React.Component {
  render() {
    const {
      idx,
      text,
      textExisted,
      userPayrolls,
      puMinusEditDisplay,
      imageEditUrl,
      toggleDisplay,
      touched,
      onInputChange,
      onInputFocus,
      handlePayrollChange,
      hasNameError,
      hasMissingName,
    } = this.props;

    return (
      <tr key={idx}>
        {textExisted ?
          <th className="item th2">
            <div className="wageTimerWrapper">
              {puMinusEditDisplay[idx] ?
                <input className={`pay-columns ${hasNameError ? 'name-length-error' : ''} ${hasMissingName ? 'name-missing-error' : ''}`} name={`puMinus6Texts[${idx}]`}
                  onChange={handlePayrollChange}
                  type="text"
                  value={text}
                />
                :
                <span className={hasMissingName ? 'name-missing-error' : ''}>{text}</span>
              }
              <button className={`btn btn-sm wageTimer wageEdit ${idx === 0 && 'hide'} indexEditMinus6_${idx} ${puMinusEditDisplay[idx] && 'btn-success'}`}
                data-bs-toggle="tooltip" disabled={hasNameError} onClick={toggleDisplay} title="時給&#013;日給"
              >
                <img alt="時" src={imageEditUrl} />
              </button>
            </div>
          </th>
          :
          <td className="item th2">
            <input className={`pay-columns ${hasNameError ? 'name-length-error' : ''} ${hasMissingName ? 'name-missing-error' : ''}`} name={`puMinus6Texts[${idx}]`}
              onChange={handlePayrollChange}
              placeholder="+ 控除項目を追加"
              type="text"
              value={text}
            />
          </td>
        }
        {userPayrolls.map((userPayroll, index) => {
          return (
            <td className="salary w9" key={index}>
              {/* #2250: 素の input だと IME 変換中イベントを親が破棄し全角入力が
                  巻き戻る。支給側 (Plus2Input) と同じ composition 対応コンポーネントで
                  確定時に半角へ変換 + 不許可文字を削除する。 */}
              <NumberOrTimePlusInput className={`inputNumber w9 ${checkIfTouchedValue(touched, userPayroll.uID, 'puMinus6s', idx) ? 'updated' : ''}`}
                data-uid={userPayroll.uID}
                inputType="puMinus6Texts"
                name={`puMinus6Texts[${userPayroll.uID}][puMinus6][${idx}]`}
                onChange={(e) => onInputChange(e, index, 'puMinus6Texts', idx)}
                onFocus={(e) => onInputFocus(e, userPayroll.uID, `puMinus6_${idx}`)}
                type="text" value={userPayroll['puMinus6Texts'][idx] || ''}
              />
            </td>
          );
        })}
      </tr>
    );
  }
}

Minus6Input.propTypes = {
  idx: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  textExisted: PropTypes.bool.isRequired,
  userPayrolls: PropTypes.array.isRequired,
  imageEditUrl: PropTypes.string.isRequired,
  puMinusEditDisplay: PropTypes.array.isRequired,
  touched: PropTypes.array.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onInputFocus: PropTypes.func.isRequired,
  handlePayrollChange: PropTypes.func.isRequired,
  toggleDisplay: PropTypes.func.isRequired,
};

export default Minus6Input;
